import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site-head" }
const _hoisted_2 = {
  href: "#content",
  class: "skip-link"
}
const _hoisted_3 = { class: "content-wrapper main-content" }

import AppHeader from '@src/components/layout/AppHeader.vue';
import AppContent from '@src/components/layout/AppContent.vue';
import DefaultSidebar from '@src/components/layout/DefaultSidebar.vue';
import AppFooter from '@src/components/layout/AppFooter.vue';
import { useI18n } from 'vue-i18n';
import { onMounted, watch } from 'vue';
import { ModalStates, useModalState } from '@src/components/shared/composables/useModalState';
import { setModalClosed, setModalOpened } from '@src/util/modalPageFreezer';

interface Props {
	assetsPath: string;
	pageIdentifier: string;
	page: object;
	pageProps?: Record<string, any>;
	hasSidebar?: boolean;
	sidebar?: object;
	sidebarProps?: Record<string, any>;
	pageTitle: string;
	bucketClasses?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    assetsPath: {},
    pageIdentifier: {},
    page: {},
    pageProps: {},
    hasSidebar: { type: Boolean, default: true },
    sidebar: {},
    sidebarProps: {},
    pageTitle: {},
    bucketClasses: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const modalState = useModalState();

onMounted( () => {
	const { t } = useI18n();
	document.title = t( 'site_name', { pageTitle: t( props.pageTitle ) } );
} );

watch( modalState, ( newModalState: ModalStates ) => {
	switch ( newModalState ) {
		case ModalStates.Open:
			setModalOpened();
			break;
		case ModalStates.Closed:
			setModalClosed();
			break;
	}
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-container", __props.bucketClasses])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t( 'skip_link_text' )), 1),
      _createVNode(AppHeader, {
        "page-identifier": __props.pageIdentifier,
        "assets-path": __props.assetsPath
      }, null, 8, ["page-identifier", "assets-path"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppContent, null, _createSlots({
        content: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.page), _normalizeProps(_guardReactiveProps(__props.pageProps)), null, 16))
        ]),
        _: 2
      }, [
        (__props.hasSidebar)
          ? {
              name: "sidebar",
              fn: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(__props.sidebar ?? DefaultSidebar), _mergeProps(__props.sidebarProps, { "assets-path": __props.assetsPath }), null, 16, ["assets-path"]))
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    _createVNode(AppFooter, {
      "page-identifier": __props.pageIdentifier,
      "assets-path": __props.assetsPath
    }, null, 8, ["page-identifier", "assets-path"])
  ], 2))
}
}

})